<template>
  <v-container id="attendance-list">
    <v-form @submit.prevent="onSubmit" ref="form">
      <v-container>
        <h2 class="w-100 text-center title-insert">
          {{ tabId > 0 ? "Editar" : "Adicionar" }} Outras Oportunidades
        </h2>
        <v-text-field
          label="Demanda"
          name="demanda"
          type="text"
          v-model="outrasOportunidades.demanda"
          required
          :rules="rules"
          background-color="white"
        />

        <v-text-field
          label="Assunto"
          name="assunto"
          type="text"
          v-model="outrasOportunidades.assunto"
          required
          :rules="rules"
          background-color="white"
        />

        <fieldset>
          <legend>Contato</legend>
          <v-row>
            <v-col v-if="!outrasOportunidades.responsavelCustomizado">
              <combobox-atores
                :filter="outrasOportunidades"
                :defaultValue="outrasOportunidades.defaultAtor"
                :municipio-id="payload.municipioId"
                :rules="rules"
                :label="'Nome'"
              ></combobox-atores>
            </v-col>
            <v-col v-if="outrasOportunidades.responsavelCustomizado">
              <v-text-field
                label="Nome"
                name="nome"
                type="text"
                :rules="rules"
                required
                v-model="outrasOportunidades.nome"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-checkbox
                v-model="outrasOportunidades.responsavelCustomizado"
                id="atuacao"
                color="primary"
                label="Nome customizado"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                label="Telefone"
                name="telefone"
                v-mask="['(##) ####-####', '(##) #####-####']"
                type="text"
                :rules="rules"
                required
                v-model="outrasOportunidades.telefone"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                label="Email"
                name="email"
                type="text"
                :rules="rules"
                required
                v-model="outrasOportunidades.email"
              ></v-text-field>
            </v-col>
          </v-row>
        </fieldset>
        <v-row>
          <v-col>
            <v-textarea
              label="Observações"
              name="observacoes"
              type="text"
              v-model="outrasOportunidades.observacoes"
              background-color="white"
            />
          </v-col>
        </v-row>
        <v-row class="row-buttons mt-4">
          <v-btn
            type="button"
            color="error"
            text
            style="margin-left: 10px"
            @click="goToList()"
          >
            Cancelar
          </v-btn>
          <v-btn color="primary" type="submit"> Salvar </v-btn>
        </v-row>
      </v-container>
    </v-form>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { AppCityHeader } from "@/modules/city";

import { outrasOportunidadesApi } from "../Api/outrasOportunidades";
import ComboboxAtores from "../../../components/combobox/atores/ComboboxAtores.vue";

export default {
  components: {
    AppCityHeader,
    ComboboxAtores,
  },
  data() {
    return {
      outrasOportunidades: {},
      payload: {
        municipioId: this.$route.params.id,
      },
      fontes: ["Municipal", "Estadual", "Federal", "Outros"],
      isEdit: false,
      tabType: this.$route.params.tab,
      tabId: this.$route.params.tabId,
      rules: [(v) => !!v || "Campo Obrigatório"],
    };
  },
  mounted() {
    if (this.tabId > 0) {
      this.setLoading(true);
      outrasOportunidadesApi
        .find(this.tabId)
        .then(({ data }) => {
          this.outrasOportunidades = data;
          this.outrasOportunidades.responsavelCustomizado =
            !this.outrasOportunidades.atorId;
          (this.outrasOportunidades.defaultAtor =
            this.outrasOportunidades.atorId),
            this.setLoading(false);
        })
        .catch((err) => {
          this.$notification.error("Erro ao encontrar recurso");
          console.log("Erro no mounted ", err);
          this.setLoading(false);
        });
    }
  },
  methods: {
    ...mapActions(["setLoading"]),
    goToList() {
      this.$router.push(
        `/cidade/${this.payload.municipioId}/agenteTerritorial/${this.tabType}`
      );
    },
    async onSubmit() {
      const valid = await this.check();

      if (!valid) return;
      this.outrasOportunidades = {
        ...this.outrasOportunidades,
        municipioId: this.payload.municipioId,
        atorId:
          (this.outrasOportunidades.ator &&
            this.outrasOportunidades.ator.idAtor) ||
          0,
        nome: this.outrasOportunidades.ator
          ? this.outrasOportunidades.ator.nome
          : this.outrasOportunidades.nome,
      };

      if (this.tabId > 0) {
        outrasOportunidadesApi
          .update(this.outrasOportunidades)
          .then(() => {
            this.$notification.success("Oportunidades editado com sucesso!");
            this.goToList();
          })
          .catch((err) => {
            this.$notification.error("Erro ao editar Oportunidades");
            console.log("Erro no submit ", err);
          });
      } else {
        outrasOportunidadesApi
          .create(this.outrasOportunidades)
          .then(() => {
            this.$notification.success("Oportunidades criado com sucesso!");
            this.goToList();
          })
          .catch((err) => {
            this.$notification.error("Erro ao criar Oportunidades");
            console.log("Erro no submit ", err);
          });
      }
    },
    async check() {
      const isValid = await this.$refs.form.validate();
      return isValid;
    },
  },
};
</script>
<style scoped>
.title-insert {
  color: #5c8bb9;
}
.row-buttons {
  display: flex;
  justify-content: end;
}
fieldset {
  padding: 10px;
  margin-bottom: 30px;
  border: 1px solid rgba(0, 0, 0, 0.87);
}
legend {
  padding: 10px;
  color: rgba(0, 0, 0, 0.6);
}
</style>
